module.exports = __webpack_public_path__ + "static/media/PM21.9bc3f482.JPG";